export default "__VITE_ASSET__f3d0B6JC__"